export default "__VITE_ASSET__BDhodNPn__"